import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getFinancialAllinList, getFinancialAllinRatio, createFinancialAllinRatio } from '@/api/bairun/financialCenter';
export default {
  name: 'FinancialAllin',
  components: {},
  data: function data() {
    return {
      total: 0,
      searchForm: {
        page: 1,
        pageSize: 20,
        stationId: 0
      },
      selectedStation: {
        'ID': 0,
        'stationName': '',
        'statTag': '选择站点',
        'statAbbr': '',
        'appId': 'aaa'
      },
      slotStats: null,
      itemSlotStats: null,
      timestamps: [],
      itemTimestamps: [],
      rules: {
        stationId: [{
          required: true,
          message: '必选',
          trigger: 'blur'
        }],
        ratioValue: [{
          required: true,
          min: 0,
          max: 100,
          type: 'number',
          message: '必填，配比范围在0~100',
          trigger: 'blur'
        }],
        dailyDate: [{
          required: true,
          message: '必填',
          trigger: 'blur'
        }]
      },
      temp: {
        stationId: null,
        ratioValue: 100,
        dailyDate: null
      },
      searchLoading: false,
      loading: false,
      itemLoading: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      slotsStationMapping: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadData();
  },
  methods: {
    stationNameShow: function stationNameShow(stationId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === stationId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    searchFormBtn: function searchFormBtn() {
      this.searchForm.page = 1;
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      getFinancialAllinRatio(this.searchForm).then(function (response) {
        _this.loading = false;
        _this.slotStats = response.data; // console.log('getFinancialAllinRatio', response.data)
        // this.slotStats = stats

        _this.total = _this.slotStats.total || 0;
        _this.timestamps = _this.slotStats.list || [];
      }).catch(function () {
        _this.loading = false;
      });
    },
    showRatioHistory: function showRatioHistory(row) {
      var _this2 = this;

      this.dialogTableVisible = true;

      if (this.itemLoading) {
        return;
      }

      this.itemLoading = true;
      getFinancialAllinList({
        stationId: row.stationId,
        page: 1,
        pageSize: 5
      }).then(function (response) {
        _this2.itemLoading = false; // console.log('getFinancialAllinList', response.data)

        _this2.itemSlotStats = response.data;
        _this2.itemTotal = _this2.itemSlotStats.total || 0;
        _this2.itemTimestamps = _this2.itemSlotStats.list || [];
      }).catch(function () {
        _this2.itemLoading = false;
      });
    },
    doCreateRatio: function doCreateRatio() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var formData = {
            stationId: _this3.temp.stationId,
            dailyDate: parseInt(_this3.temp.dailyDate),
            ratioValue: _this3.temp.ratioValue
          };
          createFinancialAllinRatio(formData).then(function (response) {
            _this3.dialogFormVisible = false; // console.log(response)

            _this3.loadData();

            _this3.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            });
          });
          _this3.temp.ratioValue = 100;
          _this3.temp.stationId = null;
          _this3.temp.dailyDate = null;
        }
      });
    }
  }
};